<template>
  <div class="HomePage" @scroll="ScrollFunc">
    <!-- 头部菜单 -->
    <BoxHead class="head" :pose="isVisible ? 'open' : 'closed'">
      <ul>
        <li v-for="(item, index) in MenuList" :key="index" @click="MenuClick(index, item)" class="transition-class"
          :class="clickIndex == index ? 'click_a' : ''">
          <a :href="item.path">{{ SeetingAll[item.name] }}</a>
        </li>
      </ul>
    </BoxHead>
    <!-- 用户简介部分 -->
    <div class="userBox" v-if="JSON.stringify(SeetingAll) != '{}'">
      <div class="user_profile" id="home">
        <ShowDiv class="user-avatar" :pose="isVisible ? 'open' : 'closed'">
          <img src="@/assets/avatar.jpg" alt="">
          <span class="img-span">👋</span>
        </ShowDiv>
        <ShowDiv class="user-name" :pose="isVisible ? 'open' : 'closed'">
          <span class="first-span">{{SeetingAll.begin}}</span>
          <h2>{{SeetingAll.name}}</h2>
          <span class="second-span">I`m a</span>
          <typeWriterVue :style="language_show=='zh'?'height:54px':''" :text="SeetingAll.typewriter"></typeWriterVue>
          <p class="user-desc">{{SeetingAll.desc}}</p>
        </ShowDiv>
        <ShowDiv class="user-other" :pose="isVisible ? 'open' : 'closed'">
          <ul>
            <li v-for="(item, index) in otherList" :key="index">
              <a :href="item.path" target="_blank">
                {{ SeetingAll[item.labelkey] }}
                <i v-if="item.icon" :class="item.icon" :style="index == 0 ? 'font-size: 1rem;' : ''"></i>
              </a>
            </li>
          </ul>
          <a href="#about" class="bottom-icon">
            <i class="el-icon-arrow-down"></i>
          </a>
        </ShowDiv>
      </div>
    </div>
    <!-- 简介 -->
    <div class="description-all">
      <ShowDiv id="about" class="user-description" :pose="isVisible ? 'open' : 'closed'">
        <h2>{{SeetingAll.about_title}}</h2>
        <pre  v-html="SeetingAll.about"></pre>
      </ShowDiv>
    </div>
    <!-- 我的项目 -->
     <div class="my-project" id="projects">
      <h2 class="my-project-h2">{{SeetingAll.project_title}}</h2>
      <projectBox class="project-list" v-for="(item,index) in SeetingAll.projectList" :key="index" :pose="gelClientHeight(index,'project-list',450,50)?'open':'closed'">
          <div class="project-item" :class="index % 2 != 0?'item-left-class':''">
            <div class="project-item-left">
              <div class="item-left-top">
                <h2>{{item.title}}</h2>
                <p class="code-class">
                  <a :href="item.code" target="_blank">
                    Code
                    <i class="el-icon-paperclip"></i>
                  </a>
                  <!-- <a href="javascript;">
                    Live demo
                    <i class="el-icon-s-promotion"></i>
                  </a> -->
                </p>
                <p class="desc-class">{{item.desc}}</p>
              </div>
              <div class="item-left-bottom">
                <span v-for="(tag, index) in item.tags" :key="index">{{tag}}</span>
              </div>
            </div>
            <div class="project-item-right">
              <el-image 
                v-if="item.img"
                :src="require(`@/static/projectImg/`+item.img)" 
                :preview-src-list="[require(`@/static/projectImg/`+item.img)]">
              </el-image>
            </div>
          </div>
      </projectBox>
      <p class="project-all">
        <a href="https://gitee.com/wu-kangkang" target="_blank">
          View All Projects <i class="el-icon-arrow-right"></i>
        </a>
      </p>
     </div>
     <!-- 我的技能 -->
     <div class="my-skill" id="skills">
       <h2 class="my-skill-h2">{{SeetingAll.skill_title}}</h2>
       <div class="skill-box">
         <skillBox class="skill-item" v-for="(item,index) in skillList" :key="index" :pose="skillIndex == index?'open':'closed'">
          {{item}}
         </skillBox>
       </div>
     </div>
     <!-- 我的经历 -->
     <div class="my-experience" id="experience">
       <h2 class="my-experience-h2">{{SeetingAll.experience_title}}</h2>
       <div class="experience-box">
          <experienceBox class="experience-item" v-for="(item,index) in SeetingAll.experienceList" :key="index" :pose="gelClientHeight(index,'experience-item',1000,500)?'open':'closed'">
           <div class="experience-item-left">
             <h3>{{item.title}}</h3>
             <p class="item-units">{{item.units}}</p>
             <pre class="item-desc">{{item.desc}}</pre>
           </div>
           <div class="experience-item-right">
            <p>{{item.label}}</p>
           </div>
           <div class="pos-img">
            <img src="@/assets/education.png" alt="" srcset="">
          </div>
          </experienceBox>
          <div class="ex-line"></div>
       </div>
     </div>
    <!-- <div style="width:100%;height:500px;max-width:90%;margin:0 auto">
      <threeFbxVue></threeFbxVue>
    </div> -->
    <!-- 切换主题、语言 -->
    <ShowDiv class="pos-rig">
      <span id="modeBtn" @click="SwitchTheme"></span>
      <span @click="settingLanguage" class="language_btn">{{language_show}}</span>
    </ShowDiv>
  </div>
</template>

<script>
import posed from "vue-pose";
import typeWriterVue from "@/views/typeWriter.vue";
import {debounce,setting_ze} from "@/utils/configured.js"
// import threeFbxVue from '../views/threeFbx.vue';

export default {
  name: "HomePage",
  components: {
    BoxHead: posed.div({
      open: {
        x: 0,
        y: -20,
        opacity: 0,
        transition: {
          y: { type: "spring", stiffness: 150, damping: 10 }, // 使用弹簧动画
          opacity: { type: "spring", stiffness: 300, damping: 24 }
        },
      },
      closed: {
        x: 0,
        y: 0,
        opacity: 1,
        transition: {
          // 这里可以定义关闭时的动画效果
          y: { type: "spring", stiffness: 150, damping: 10 },
          opacity: { type: "spring", stiffness: 300, damping: 24 },
        },
      },
    }),
    ShowDiv: posed.div({
      open: {
        scale: 0,
        transition: {
          opacity: { type: "spring", stiffness: 300, damping: 24 }
        }
      },
      closed: {
        scale: 1,
        transition: {
          opacity: { type: "spring", stiffness: 300, damping: 24 }
        }
      }
    }),
    projectBox:posed.div({
      open: {
        scale: 0.8,
        opacity: 0.6,
        y:-20,
        transition: {
          y: { type: "spring", stiffness: 150, damping: 10 }, // 使用弹簧动画
          opacity: { type: "spring", stiffness: 300, damping: 24 }
        }
      },
      closed: {
        scale: 1,
        opacity: 1,
        y:0,
        transition: {
          y: { type: "spring", stiffness: 150, damping: 10 }, // 使用弹簧动画
          opacity: { type: "spring", stiffness: 300, damping: 24 }
        }
      }
    }),
    skillBox:posed.div({
      open: {
        x: -10,
        y: 50,
        opacity: 0,
        transition: {
          y: { type: "spring", stiffness: 150, damping: 10 }, // 使用弹簧动画
          x: { type: "spring", stiffness: 150, damping: 10 }, // 使用弹簧动画
          opacity: { type: "spring", stiffness: 300, damping: 24 }
        }
      },
      closed: {
        x: 0,
        y: 0,
        opacity: 1,
        transition: {
          y: { type: "spring", stiffness: 150, damping: 10 }, // 使用弹簧动画
          x: { type: "spring", stiffness: 150, damping: 10 }, // 使用弹簧动画
          opacity: { type: "spring", stiffness: 300, damping: 24 }
        }
      }
    }),
    experienceBox:posed.div({
      open: {
        x: 550,
        y: 0,
        opacity: 0,
        transition: {
          y: { type: "spring", stiffness: 150, damping: 10 }, // 使用弹簧动画
          x: { type: "spring", stiffness: 150, damping: 10 }, // 使用弹簧动画
          opacity: { type: "spring", stiffness: 300, damping: 24 }
        }
      },
      closed: {
        x: 0,
        y: 0,
        opacity: 1,
        transition: {
          y: { type: "spring", stiffness: 150, damping: 10 }, // 使用弹簧动画
          x: { type: "spring", stiffness: 150, damping: 10 }, // 使用弹簧动画
          opacity: { type: "spring", stiffness: 300, damping: 24 }
        }
      }
    }),
    typeWriterVue,
    // threeFbxVue
  },
  data() {
    return {
      isVisible: true,
      MenuList: [
        {
          name: "home",
          path: "#home",
        },
        {
          name: "aboutme",
          path: "#about",
        },
        {
          name: "projects",
          path: "#projects",
        },
        {
          name: "skills",
          path: "#skills",
        },
        {
          name: "experience",
          path: "#experience",
        },
      ],
      clickIndex: 0,
      otherList: [
        // {
        //   labelkey: 'resume',
        //   icon: 'el-icon-download',
        //   path:''
        // },
        {
          labelkey: 'git',
          icon: '',
          path:'https://gitee.com/wu-kangkang'
        },
        // {
        //   labelkey: '',
        //   icon: 'el-icon-platform-eleme'
        // },
        {
          labelkey: 'bk',
          icon: '',
          path:'https://strive-forward.blog.csdn.net'
        },
      ],
      SeetingAll:{},
      language_show:'zh',
      viewHeight:0,
      skillList:[],
      skillIndex:0,
      SkillFlag:false
    };
  },
  created(){
    if(!sessionStorage.getItem('type_zh')){
      sessionStorage.setItem('type_zh','zh')
    }
    if(!sessionStorage.getItem('type_theme')){
      sessionStorage.setItem('type_theme','light')
    }
    document.body.classList.add(sessionStorage.getItem('type_theme'))
    this.language_show = sessionStorage.getItem('type_zh')
    this.getLanguage()
  },
  methods: {
    SwitchTheme(){
      if(document.body.classList.contains('dark')){
        document.body.classList.remove('dark')
        document.body.classList.add('light')
        sessionStorage.setItem('type_theme','light')
      }else{
        document.body.classList.add('dark')
        document.body.classList.remove('light')
        sessionStorage.setItem('type_theme','dark')
      }
    },
    gelClientHeight(index,name,height = 0,clientHeight = 0){
      return (this.viewHeight - height - clientHeight * index) < (document.querySelectorAll('.'+name)[index] && document.querySelectorAll('.'+name)[index].getBoundingClientRect().top)
    },
    settingLanguage(){
      let type = sessionStorage.getItem('type_zh')
      sessionStorage.setItem('type_zh',type=='zh'?'en':'zh')
      this.language_show = type=='zh'?'en':'zh'
      this.getLanguage()
    },
    getLanguage(){
      let type = sessionStorage.getItem('type_zh')
      let setting = JSON.parse(JSON.stringify(setting_ze))
      for (let i in setting) {
        this.SeetingAll[i] = setting[i][type]
      }
    },
    MenuClick(index, item) {
      if (this.clickIndex == index) return
      this.clickIndex = index;
    },
    ScrollFunc:debounce(
        function(e){
          this.viewHeight = e.target.scrollTop
          if(e.target.scrollTop < 400){
            this.clickIndex = 0
          }else if(e.target.scrollTop >= 400 && e.target.scrollTop < 1000){
            this.clickIndex = 1
          }else if(e.target.scrollTop >= 1000 && e.target.scrollTop < 2400){
            this.clickIndex = 2
          }else if(e.target.scrollTop >= 2400 && e.target.scrollTop < 2700){
            this.clickIndex = 3
          }else{
            this.clickIndex = 4
          }
          if(e.target.scrollTop >= 2200){
            if(this.skillList.length < this.SeetingAll['skillList'].length && this.skillIndex < this.SeetingAll['skillList'].length && !this.SkillFlag){
              this.SkillFlag = true
              for (let index = 0; index < this.SeetingAll['skillList'].length; index++) {
                  let element = this.SeetingAll['skillList'][index]
                  setTimeout(() => {
                    this.skillList.push(element)
                    this.skillIndex += 1
                  }, 100 * index);
              }
            }
          }
        },100,false
    )
  },

  mounted() {
    setTimeout(() => {
      this.isVisible = !this.isVisible;
    }, 200);
  },
  beforeDestroy() {
  }
};
</script>
<style lang="less" scoped>
.HomePage {
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: auto;
  scroll-behavior: smooth;
  overflow-x: hidden;

  .head {
    width: 100%;
    height: 50px;
    display: flex;
    align-content: center;
    justify-content: center;
    position: fixed;
    top: 2rem;
    max-width: 100%;
    z-index: 999;

    ul {
      width: 32rem;
      max-width: 90%;
      height: 100%;
      background-color: var(--theme-head-bacg);
      backdrop-filter: blur(10px);
      border-color: rgb(255 255 255 / 0.4);
      border-radius: 50px;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.03),
        0 4px 6px -4px rgba(0, 0, 0, 0.03);
      display: flex;
      padding: 0px 15px;
      justify-content: space-around;
      align-items: center;

      li {
        a {
          padding: 8px 15px;
          font-size: 1rem;
          color: var(--theme-head-a-color);
          transition: all .3s;
        }

        &:hover {
          a {
            color: var(--theme-head-a-hover-color);
          }
        }
      }

      .click_a {
        a {
          background-color: #fff;
          color: var(--theme-head-a-hover-color);
          border-radius: 25px;
        }
      }

      .transition-class {
        transition: background-color 0.3s ease;
      }
    }
  }

  .userBox {
    width: 100%;
    height: auto;
    background: linear-gradient(to right, var(--theme-home-left), var(--theme-home-right));
    background: linear-gradient(to bottom, var(--theme-home-top), var(--theme-home-bottom));

    .user_profile {
      width: 450px;
      max-width: 90%;
      height: auto;
      margin: 0 auto;
      padding-top: 120px;

      .user-avatar {
        width: 112px;
        height: 112px;
        border-radius: 50%;
        border: 4px solid #fff;
        margin: 0 auto;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }

        .img-span {
          display: inline-block;
          width: 46px;
          height: 40px;
          position: absolute;
          right: 0;
          bottom: 0;
          font-size: 32px;
          z-index: 999999;
          transition: all .3s;

          &:hover {
            cursor: pointer;
            transform: scale(1.2) rotate(15deg);
          }
        }
      }

      .user-name {
        text-align: center;
        margin-top: 30px;

        .first-span {
          font-size: 1rem;
        }

        h2 {
          margin-top: 10px;
          margin-bottom: 20px;
          font-size: 2rem;
        }

        .second-span {
          font-size: 14px;
          // color: #030712;
          margin-bottom: 15px;
          display: inline-block;
        }

        .user-desc {
          margin-top: 10px;
          font-size: 2.25rem;
        }
      }

      .user-other {
        width: 100%;
        min-height: 50px;
        margin-top: 50px;
        padding-bottom: 50px;

        ul {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          li {
            max-width: 150px;
            padding: 10px;
            background-color: var(--theme-other-color);
            border-radius: 30px;
            font-size: 1rem;
            transition: all .3s;
            margin: 0px 10px;

            a {
              width: 100%;
              height: 100%;
              color: var(--theme-head-a-color);
              display: inline-block;

              i {
                font-size: 1.5rem;
              }
            }

            &:hover {
              transform: scale(1.15);
              cursor: pointer;

              a {
                color: var(--theme-default-color);
              }
            }
          }
        }

        .bottom-icon {
          width: 100%;
          text-align: center;
          margin-top: 50px;
          display: inline-block;
          i{
            transition: all .3s;
            color: var(--theme-default-color);
          }

          &:hover {
            i{
              cursor: pointer;
              transform: scale(1.25);
            }
          }
        }
      }
    }
  }

  // 简介
  .description-all{
    background: linear-gradient(to bottom, var(--theme-home-bottom), var(--theme-all-bacg));
    width: 100%;
  }
  .user-description {
    max-width: 90%;
    width: 50rem;
    line-height: 25px;
    margin: 0 auto;
    padding-top: 50px;
    padding-bottom: 20px;

    h2{
      font-size: 3rem;
      font-weight: 500;
      text-align: center;
      margin-bottom: 10px;
    }

    pre {
      font-size: 1.15rem;
      color: var(--theme-default-text-color);
      white-space: pre-line;
    }
  }
  // 我的项目
  .my-project{
    width: 100%;
    min-height: 500px;
    .my-project-h2{
      width: 50rem;
      max-width: 98%;
      margin: 0 auto;
      text-align: center;
      font-size: 2.5rem;
      font-weight: 500;
      margin-bottom: 5rem;
      margin-top: 7rem;
    }
    .project-list{
      width: 45rem;
      max-width: calc(100% - 8rem);
      margin: 0 auto;
      background-color: var(--theme-project-bacg-color);
      padding: 2rem;
      border-radius: 8px;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.03),
        0 4px 6px -4px rgba(0, 0, 0, 0.03);
      margin-bottom: 2rem;
      overflow: hidden;

      .project-item{
        width: calc(100% - 2rem);
        height: 24rem;
        padding: 1rem;
        align-items: center;
        justify-content: space-between;
        transition: all .3s;
        display: flex;
        .project-item-left{
          width: 50%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-right: 3rem;
          .item-left-top{
            display: flex;
            flex-direction: column;
            h2{
              width: 100%;
              max-height: 8rem;
              font-size: 2rem;
              font-weight: 500;
              margin-bottom: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box; //设置排列方式为 弹性盒子排列方式
              -webkit-box-orient: vertical; //子元素排列方式  horizontal 横向排序;   vertical 纵向排序; inherit 继承父元素排序方式
              -webkit-line-clamp: 2; //显示多少行的内容
              word-break: break-all;
              &:hover{
                text-decoration: underline;
              }
            }
            .code-class{
              a{
                color: var(--theme-default-color);
                font-size: 1.15rem;
                margin-right: 1rem;
                &:hover{
                  text-decoration: underline;
                }
              }
            }
            .desc-class{
              margin-top: 1rem;
              max-height: 12rem;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box; //设置排列方式为 弹性盒子排列方式
              -webkit-box-orient: vertical; //子元素排列方式  horizontal 横向排序;   vertical 纵向排序; inherit 继承父元素排序方式
              -webkit-line-clamp: 6; //显示多少行的内容
              word-break: break-all;
              line-height: 2rem;
            }
          }
          .item-left-bottom{
            span{
              display: inline-block;
              padding: .5rem .8rem;
              background-color: var(--theme-tag-bac-color);
              color: var(--theme-other-color);
              margin-left: .5rem;
              border-radius: 1rem;
              margin-bottom: 5px;
            }
          }
        }
        .project-item-right{
          width: 50%;
          height: 100%;
          // background-color: skyblue;
          position: relative;
          .el-image{
            position: absolute;
            top: 50%;
            right: -19rem;
            transform: translate(0,-50%);
            height: 20rem;
            border-radius: 8px;
            transition: all .3s;
            img{
              border-radius: 8px;
            }
          }
        }
      }
      .item-left-class{
        flex-direction: row-reverse;
        .project-item-right{
          .el-image{
            left: -19rem;
            right: 5rem;
          }
        }
      }
      &:hover{
        cursor: pointer;
        h2{
          color: var(--theme-project-title-color);
        }
        .project-item-right{
          .el-image{
            transform: translateY(-10rem) rotate(-2deg) skew(0,0) scale(1.12);
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);  
          }
        }
        .item-left-class{
          .project-item-right{
            .el-image{
              transform: translateY(-10rem) rotate(2deg) skew(0,0) scale(1.12);
              box-shadow: 0 4px 6px rgba(0,0,0,0.1);  
            }
          }
        }
      }
    }
    .project-all{
      width: 45rem;
      max-width: calc(100% - 8rem);
      margin: 0 auto;
      text-align: center;
      margin-top: 3rem;
      a{
        color: var(--theme-projects-desc-text);
        font-weight: 600;
        font-size: 1.2rem;
      }
      i{
        transition: all .3s;
        font-weight: 600;
        color: var(--theme-projects-desc-text);
        font-size: 1rem;
      }
      &:hover{
        cursor: pointer;
          a{
            text-decoration: underline;
            text-underline-offset: 4px;
            text-decoration-color: #d22d68;
          }
          i{
            transform: translateX(5px);
          }
      }
    }
  }
  // 我的技能
  .my-skill{
    width: 45rem;
    max-width: calc(100% - 8rem);
    margin: 0 auto;
    margin-top: 4rem;
    .my-skill-h2{
      width: 50rem;
      max-width: 98%;
      margin: 0 auto;
      text-align: center;
      font-size: 2.5rem;
      font-weight: 500;
      margin-bottom: 5rem;
      margin-top: 7rem;
    }
    .skill-box{
      max-width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: center;
      .skill-item{
        max-height: 3rem;
        padding: .8rem 1rem;
        background-color: var(--theme-skill-bacg-color);
        border-radius: 1rem;
        margin-bottom: 1rem;
        margin-right: .5rem;
        font-size: 1.2rem;
      }
    }
  }
  // 我的经历
  .my-experience{
    width:70rem;
    max-width: calc(100% - 8rem);
    margin: 0 auto;
    margin-top: 4rem;
    padding-bottom: 5rem;
    .my-experience-h2{
      width: 50rem;
      max-width: 98%;
      margin: 0 auto;
      text-align: center;
      font-size: 2.5rem;
      font-weight: 500;
      margin-bottom: 5rem;
      margin-top: 7rem;
    }
    .experience-box{
      position: relative;
      // height: 50rem;
      padding-top: .5rem;
      padding-bottom: .5rem;
      .experience-item{
        max-width: 100%;
        // background-color: pink;
        margin-top: 3rem;
        display: flex;
        padding: 1.5rem;
        position: relative;
        .experience-item-left{
          width: 43%;
          height: 100%;
          background-color: var(--theme-skill-bacg-color);
          margin-right: 5%;
          line-height: 1.8rem;
          border-radius: .5rem;
          padding: .8rem;
          h3{
            font-weight: 600;
            font-size: 1.5rem;
          }
          .item-units{
            margin: .5rem 0;
          }
          .item-desc{
            font-size: 0.9rem;
            text-indent: 2em;
            white-space: pre-line;
            line-height: 1.6rem;
            margin-top: -1.5rem;
          }
        }
        .experience-item-right{
          width: 15rem;
          height: 100%;
          // background-color: yellowgreen;
          padding-left: 2rem;
        }
        .pos-img{
          width: 3rem;
          height: 3rem;
          border: .4rem var(--theme-default-text-color) solid;
          border-radius: 50%;
          background-color: var(--theme-other-color);
          position: absolute;
          left: 50%;
          top: 0;
          transform: translate(-50%, 0);
          z-index: 9;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
      .ex-line{
        position: absolute;
        width: .4rem;
        height: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        background-color: var(--theme-project-bacg-color);
      }
    }
  }
  // 右边其他操作
  .pos-rig{
    width: 2.5rem;
    height: 8rem;
    max-width: 40px;
    max-height: 80px;
    padding: 10px;
    position: fixed;
    right: 2rem;
    bottom: 2rem;
    background-color: rgba(251, 252, 253, 0.5);
    backdrop-filter: blur(.5rem);
    border-color: rgb(255 255 255 / 0.4);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.03),
      0 4px 6px -4px rgba(0, 0, 0, 0.03);
      border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    overflow: hidden;
    flex-direction: column;
    .language_btn{
      display: inline-block;
      color: #374151;
      text-align: center;
      font-size: 1.2rem;
      transition: all .3s;
      margin-top: 10px;
      &:hover{
        cursor: pointer;
        color: #333;
        transform: scale(1.2);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue